import React, { useContext } from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';

import DetailNav from './DetailNav';

import './DetailHeader.scss';

const DetailHeader = ( {
  className,
  text,
  navBtns,
  navClass,
} ) => {

  return (
    <>
      <div className={classNames(
        'detailHeader', className, {
          'detailHeader--hasSubtitle': text?.subtitle,
        } )
    }
      >

        <div className="detailHeader__text">
          <h2 className="detailHeader__title">

            <span>
              { text?.title }
            </span>

            { text?.tags?.map( ( item ) => (
              <span
                key={item.type}
                className={`detailHeader__tag detailHeader__tag--${item.type} detailHeader__tag--paneTag`}
              >
                {item.text}
              </span>
            ) )}
          </h2>

          { text?.subtitle && (
            <h3 className="detailHeader__subtitle">{text.subtitle}</h3>
          )}

        </div>

      </div>

      <DetailNav
        navBtns={navBtns}
        navClass={navClass}
      />
    </>
  );
};

DetailHeader.propTypes = {
  className: propTypes.string,
  text: propTypes.shape( {
    title: propTypes.string,
    subtitle: propTypes.string,
  } ),
  navBtns: propTypes.arrayOf(
    propTypes.shape({
      text: propTypes.string,
      link: propTypes.string,
    }),
  ),
  navClass: propTypes.string,
};

DetailHeader.defaultProps = {
  className: '',
  text: {
    title: null,
    subtitle: null,
  },
  navBtns: [],
  navClass: '',
};

export default DetailHeader;
